import React, { useContext, useEffect, useState } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setShowSpeechBubble,
    setAttributionCopied
} from "core/AssetDownload/Context/actions";

// styles
import { ThankYouBubbleStyled, Bubble, Pointer } from "./styles";

// settings
// Triggered by Context State `showSpeechBubble`
// transitional pauses/duration handled by local state `isVisible`
const TIMER_INITIAL_DELAY = 1200; // a delay before animation begins
const TIMER_SHOW_BUBBLE_DURATION = 4000; // how long speech bubble persists, before it fades away

const ThankYouSpeechBubble = () => {
    const [isVisible, isVisibleUpdate] = useState(false);
    const { state, dispatch } = useContext(AssetDownloadContext);
    const { showSpeechBubble } = state;

    useEffect(() => {
        if (showSpeechBubble) {
            setTimeout(() => {
                isVisibleUpdate(true);

                setTimeout(() => {
                    isVisibleUpdate(false);
                    dispatch(setShowSpeechBubble(false));
                }, TIMER_SHOW_BUBBLE_DURATION);
            }, TIMER_INITIAL_DELAY);
        }
    }, [showSpeechBubble]);

    return (
        <ThankYouBubbleStyled isVisible={isVisible}>
            <Bubble>Thanks!</Bubble>
            <Pointer />
        </ThankYouBubbleStyled>
    );
};

export default ThankYouSpeechBubble;
